// extracted by mini-css-extract-plugin
export default {"root":"vpck4l","averageRating":"Frkzik","text":"byYxpD","reviews":"j01PQg"};